import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVICE_PCP_URL } from '../../tokens';
import { UserRulesService } from 'src/app/shared/services/user-rules.service';

@Injectable({
  providedIn: 'root'
})
export class PcpsService {
  currentSelectedPcpId = '';

  constructor(private http: HttpClient, @Inject(SERVICE_PCP_URL) private servicePCPUrl: any, private _userRulesService: UserRulesService) {
    this.servicePCPUrl = `${servicePCPUrl}`;
  }

  savePcps(providerNumber: string, pcpId?: string, officeId?: string, reasonCode?: string): Observable<any> {
    const pcpsData = {
      memberId: this._userRulesService.getPrimaryId(),
      pcpId: pcpId ? pcpId : officeId,
      providerId: providerNumber,
      reasonCode: reasonCode ? reasonCode : 'MS'
    };
    this.currentSelectedPcpId = pcpId ? pcpId : '';

    return this.http.put(this.servicePCPUrl, pcpsData, { headers: { useAuth: 'token'}});
  }

}
